import React from 'react';
import Container from '../../components/Container/Container';
import successSvg from './../Utils/Assets/success.svg';
import { DatabaseOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box, Button } from '@mui/material';

function OrderComplete() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onGoBack = () => {
    dispatch({ type: 'RESET_FMCG_REDUCER' });
    dispatch({ type: 'CLEAR_RETAILERS' });
    dispatch({ type: 'RESET_BCM_ORDER' });

    navigate('/distributor/company-wise-inventory', { replace: true });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '25px',
        height: '100vh',
      }}
    >
      <div className='successContainer'>
        <img
          className='successImg'
          src={successSvg}
          alt='success'
        />
        <p className='successTitle'>
          Your order is successfully fulfilled from inventory
        </p>
        <Button
          fullWidth
          onClick={onGoBack}
          startIcon={<DatabaseOutlined />}
          className='returnToInventory'
          variant='outlined'
        >
          Return To Inventory
        </Button>
      </div>
    </Box>
  );
}

export default OrderComplete;
